import { render } from "./myFindings.vue?vue&type=template&id=4f099afd&scoped=true&ts=true"
import script from "./myFindings.vue?vue&type=script&lang=ts"
export * from "./myFindings.vue?vue&type=script&lang=ts"

import "./myFindings.vue?vue&type=style&index=0&id=4f099afd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f099afd"]])

export default __exports__